import { Stack, Typography, TextField, MenuItem, CircularProgress, Box } from '@mui/material';
import { useKanbanSettings, useUpdateKanbanSettings, KANBAN_MODE_DEFAULT, type KanbanBoardMode } from '../../api/hooks/useKanbanSettings';
import { useNotifications } from '../../context/NotificationContext';

/** Mandanten-Standardmodus für die Kanban-Darstellung (T-071). Einzelne Projekte
 *  überschreiben diesen Standard direkt im Kanban-Tab. */
export function KanbanSettingsManager() {
  const { data, isLoading } = useKanbanSettings();
  const updateMut = useUpdateKanbanSettings();
  const { notify } = useNotifications();

  const mode = (data as { data?: { board_mode?: KanbanBoardMode } } | undefined)?.data?.board_mode ?? KANBAN_MODE_DEFAULT;

  const handleChange = async (value: string) => {
    try {
      await updateMut.mutateAsync({ board_mode: value as KanbanBoardMode });
      notify('Standard-Darstellung gespeichert', 'success');
    } catch {
      notify('Speichern fehlgeschlagen', 'error');
    }
  };

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={20} /></Box>;
  }

  return (
    <Stack spacing={1.5}>
      <Typography variant="body2" color="text.secondary">
        Standard-Darstellung des Kanban-Boards für alle Projekte dieses Mandanten. Einzelne Projekte können im jeweiligen Kanban-Tab davon abweichen.
      </Typography>
      <TextField
        select size="small"
        label="Standard-Darstellung"
        value={mode}
        onChange={(e) => handleChange(e.target.value)}
        disabled={updateMut.isPending}
        sx={{ maxWidth: 400 }}
      >
        <MenuItem value="per_ap">Pro Arbeitspaket — ein Board je AP (z. B. ein Board pro Team/Standort)</MenuItem>
        <MenuItem value="per_project">Ein Board pro Projekt — Summe aller Aufgaben aller Arbeitspakete</MenuItem>
      </TextField>
    </Stack>
  );
}
